var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 36,
    height: 36,
    rx: 4,
    fill: "#F1EEEC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6665 22.6667L17.9998 26M17.9998 26L21.3332 22.6667M17.9998 26V18.5M24.6665 22.4524C25.6844 21.6117 26.3332 20.3399 26.3332 18.9167C26.3332 16.3854 24.2811 14.3333 21.7498 14.3333C21.5677 14.3333 21.3974 14.2383 21.3049 14.0814C20.2182 12.2374 18.2119 11 15.9165 11C12.4647 11 9.6665 13.7982 9.6665 17.25C9.6665 18.9718 10.3627 20.5309 11.489 21.6613",
    stroke: "#77553D",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.9d6db2ba60a1384d44e8e85a2092da44.svg";
export { ForwardRef as ReactComponent };